module.exports = __webpack_public_path__ + "img/Intermediate Of Computer Science.ada73379.svg";